import { render, staticRenderFns } from "./chat_client.vue?vue&type=template&id=58ae0cf5&scoped=true"
import script from "./chat_client.vue?vue&type=script&lang=js"
export * from "./chat_client.vue?vue&type=script&lang=js"
import style0 from "./chat_client.vue?vue&type=style&index=0&id=58ae0cf5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ae0cf5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/vagrant/git/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58ae0cf5')) {
      api.createRecord('58ae0cf5', component.options)
    } else {
      api.reload('58ae0cf5', component.options)
    }
    module.hot.accept("./chat_client.vue?vue&type=template&id=58ae0cf5&scoped=true", function () {
      api.rerender('58ae0cf5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chat/chat_client.vue"
export default component.exports